import { type ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { useCurrentCaseContext } from "~/pages/Compliance/context/CurrentCaseContext";
import { useIsFatcaCrsEnabledForCase } from "~/pages/Compliance/flags";
import DateFieldFormValue from "../ReusableFormValues/DateFieldFormValue";
import SubTypeDocumentSelector from "../SubTypeDocumentSelector";
import { useWSeriesTaxFormTypesArray } from "./constants";

export type Props = {
  readonly: boolean;
  documentName?: string;
};

const WSeriesTaxDocFormValues = ({ readonly, documentName = "" }: Props) => {
  const wSeriesTaxFormTypesArray = useWSeriesTaxFormTypesArray();
  const { caseType, fatcaCrsEnabled } = useCurrentCaseContext();
  const isFatcaCrsEnabled = useIsFatcaCrsEnabledForCase(
    caseType as ComplianceCaseTypeEnum | undefined,
    fatcaCrsEnabled,
  );

  return (
    <>
      <SubTypeDocumentSelector
        readonly={readonly}
        subTypeDocuments={wSeriesTaxFormTypesArray}
        placeholder="Select a W series tax form document type"
        name="secondaryDocumentType"
        label="Document sub-type"
        documentName={documentName}
      />
      {!isFatcaCrsEnabled && (
        <DateFieldFormValue
          name="date"
          label="Date of signature"
          readonly={readonly}
          maxDate={new Date()}
          showExpiredWarning
        />
      )}
    </>
  );
};

export default WSeriesTaxDocFormValues;
